// Color vocabulary (which families and stops exist) shared across frontend,
// backend, and validation. The hex *rendering* of these (Tailwind scales,
// getColorStop) stays on the frontend in styles/colorStops.ts, since it derives
// from tailwindcss and the backend never resolves colors to hex.
export const COLOR_STOPS = [
    '50',
    '100',
    '200',
    '300',
    '400',
    '500',
    '600',
    '700',
    '800',
    '900',
    '950',
];
//# sourceMappingURL=colorStops.js.map